import { motion } from 'framer-motion';
import { Layout } from '@/components/Layout';
import { PageHero, NewsCard } from '@/components/Cards';
import { useLanguage } from '@/hooks/useLanguage';

const newsItems = [
  {
    title: 'Yaruwat Expands GACC-Registered Orchard Network in Eastern Thailand',
    titleTh: 'ยารุวาทขยายเครือข่ายสวนผลไม้ที่ขึ้นทะเบียน GACC ในภาคตะวันออกของประเทศไทย',
    excerpt: 'Yaruwat Co., Ltd. announces the addition of 15 new GACC-registered orchards in Chanthaburi province, significantly increasing export capacity for durian and other premium tropical fruits to China.',
    excerptTh: 'บริษัท ยารุวาท จำกัด ประกาศเพิ่มสวนผลไม้ที่ขึ้นทะเบียน GACC ใหม่ 15 แห่งในจังหวัดจันทบุรี เพิ่มกำลังการส่งออกทุเรียนและผลไม้เขตร้อนพรีเมียมอื่นๆ ไปยังจีนอย่างมีนัยสำคัญ',
    date: 'March 15, 2026',
    category: 'Business News',
    categoryTh: 'ข่าวธุรกิจ',
    image: '/images/fruits_2.jpeg',
  },
  {
    title: 'AI Live Streaming Division Records 300% Growth in Chinese Market Sales',
    titleTh: 'แผนกไลฟ์สดด้วย AI บันทึกการเติบโต 300% ในยอดขายตลาดจีน',
    excerpt: 'Yaruwat\'s pioneering AI live streaming e-commerce division achieves record sales figures, with Thai products reaching over 5 million Chinese consumers through major platforms in Q1 2026.',
    excerptTh: 'แผนกอีคอมเมิร์ซไลฟ์สดด้วย AI ของยารุวาทบรรลุตัวเลขยอดขายสถิติ โดยสินค้าไทยเข้าถึงผู้บริโภคชาวจีนกว่า 5 ล้านคนผ่านแพลตฟอร์มหลักในไตรมาส 1 ปี 2026',
    date: 'February 28, 2026',
    category: 'Technology',
    categoryTh: 'เทคโนโลยี',
    image: '/images/ai_live_7.jpeg',
  },
  {
    title: 'Partnership with Xianpinda Strengthens Thailand-China Trade Corridor',
    titleTh: 'ความร่วมมือกับ Xianpinda เสริมสร้างเส้นทางการค้าไทย-จีน',
excerpt: 'The strategic partnership between Yaruwat and Xianpinda () enters its next phase with joint distribution agreements covering Thailand\'s premium fruits, coffee, and specialty food products.',
excerptTh: 'ความร่วมมือเชิงกลยุทธ์ระหว่างยารุวาทและ Xianpinda () เข้าสู่ระยะต่อไปด้วยข้อตกลงการจัดจำหน่ายร่วมที่ครอบคลุมผลไม้พรีเมียม กาแฟ และผลิตภัณฑ์อาหารพิเศษของประเทศไทย',
    date: 'January 20, 2026',
    category: 'Partnership',
    categoryTh: 'ความร่วมมือ',
    image: '/images/hero_5.jpeg',
  },
  {
    title: 'Thai Highland Coffee Wins International Specialty Coffee Award',
    titleTh: 'กาแฟไทยที่ราบสูงได้รับรางวัลกาแฟสเปเชียลตี้นานาชาติ',
    excerpt: 'Yaruwat\'s sourced Thai highland Arabica coffee from Doi Inthanon region receives top honors at the Asia Pacific Specialty Coffee Expo, opening new export opportunities.',
    excerptTh: 'กาแฟอาราบิก้าไทยที่ราบสูงที่จัดหาโดยยารุวาทจากพื้นที่ดอยอินทนนท์ได้รับเกียรติสูงสุดในงาน Asia Pacific Specialty Coffee Expo เปิดโอกาสส่งออกใหม่',
    date: 'December 10, 2025',
    category: 'Awards',
    categoryTh: 'รางวัล',
    image: '/images/coffee_4.jpeg',
  },
  {
    title: 'Yaruwat Medical Division Expands Into Rehabilitation Equipment',
    titleTh: 'แผนกการแพทย์ยารุวาทขยายสู่อุปกรณ์ฟื้นฟูสมรรถภาพ',
    excerpt: 'Responding to growing demand in Southeast Asia\'s rehabilitation sector, Yaruwat announces new partnerships with European rehabilitation equipment manufacturers to expand its medical portfolio.',
    excerptTh: 'ตอบสนองต่อความต้องการที่เพิ่มขึ้นในภาคการฟื้นฟูสมรรถภาพของเอเชียตะวันออกเฉียงใต้ ยารุวาทประกาศความร่วมมือใหม่กับผู้ผลิตอุปกรณ์ฟื้นฟูสมรรถภาพยุโรปเพื่อขยายพอร์ตโฟลิโอทางการแพทย์',
    date: 'November 5, 2025',
    category: 'Medical',
    categoryTh: 'การแพทย์',
    image: '/images/medical_5.jpeg',
  },
  {
    title: 'Thailand-China Free Trade Agreement Creates New Opportunities for Yaruwat',
    titleTh: 'ข้อตกลงการค้าเสรีไทย-จีนสร้างโอกาสใหม่สำหรับยารุวาท',
    excerpt: 'As Thailand and China deepen trade ties, Yaruwat is well-positioned to leverage new tariff advantages and streamlined customs procedures to accelerate growth across all business segments.',
    excerptTh: 'เมื่อไทยและจีนกระชับความสัมพันธ์ทางการค้า ยารุวาทอยู่ในตำแหน่งที่ดีในการใช้ประโยชน์จากข้อได้เปรียบภาษีใหม่และขั้นตอนศุลกากรที่คล่องตัวขึ้นเพื่อเร่งการเติบโตในทุกภาคธุรกิจ',
    date: 'October 18, 2025',
    category: 'Trade Policy',
    categoryTh: 'นโยบายการค้า',
    image: '/images/hero_1.jpeg',
  },
];

export default function News() {
  const { t } = useLanguage();

  return (
    <Layout>
      <PageHero
        title="News & Insights"
        titleTh="ข่าวสารและบทความ"
        subtitle="Latest updates from Yaruwat and the industries we serve"
        subtitleTh="อัปเดตล่าสุดจากยารุวาทและอุตสาหกรรมที่เราให้บริการ"
        image="/images/hero_4.jpeg"
      />

      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Featured Article */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="group relative bg-card rounded-2xl overflow-hidden shadow-lg border border-border/50 md:flex">
              <div className="md:w-1/2 h-64 md:h-auto relative overflow-hidden">
                <img
                  src={newsItems[0].image}
                  alt={newsItems[0].title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 bg-primary text-primary-foreground text-xs font-semibold px-3 py-1 rounded-full">
                  {t('Featured', 'บทความเด่น')}
                </span>
              </div>
              <div className="md:w-1/2 p-8 flex flex-col justify-center">
                <span className="text-primary text-sm font-semibold mb-2">
                  {t(newsItems[0].category, newsItems[0].categoryTh)} · {newsItems[0].date}
                </span>
                <h2 className="text-2xl font-bold text-foreground mb-4 leading-tight">
                  {t(newsItems[0].title, newsItems[0].titleTh)}
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  {t(newsItems[0].excerpt, newsItems[0].excerptTh)}
                </p>
              </div>
            </div>
          </motion.div>

          {/* News Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {newsItems.slice(1).map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <NewsCard {...item} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
